<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {shareStart} from "@/utils/common";

export default {
  name: "App",
  mounted() {
    // // 配置微信分享参数
    // setTimeout(() => {
    //   // 判断是否在微信内
    //   if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
    //     shareStart(window.location.href, "智云鸿道", "助力思政教育 传承中华文化  创新党史学习", "http://h5.cdzyhd.com/images/logo_weixin_share.png")
    //   }
    // }, 500)
  }
}
</script>

<style>
</style>
